import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { AlertState, StoreError } from './types'
import { AlertInterface, AlertService } from '@/domain/services/AlertService'

const account: AlertInterface = new AlertService()

export const actions: ActionTree<AlertState, RootState> = {
  async getAlerts ({ commit }) {
    try {
      const actionResponse = await account.getAlerts()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  }
}
